<nav class="t-header">
  <div class="t-header-brand-wrapper">
    <img class="logo" src="../assets/images/logo.png" alt="">
  </div>
  <div class="t-header-content-wrapper">
    <div class="t-header-content">
      <button class="t-header-toggler t-header-mobile-toggler d-block d-lg-none" (click)="sidebarState = !sidebarState">
        <i class="mdi mdi-menu"></i>
      </button>

      <li class="search-box">
        <ng-select
          [items]="completeSubOrgsList"
          placeholder="Organizations"
          [(ngModel)]="userService.tempOrgID"
          (change)="selectTempOrgID($event)"
          (clear)="selectTempOrgID(false)"
          [multiple]="false"
          [virtualScroll]="true"
          bindLabel="name"
          bindValue="id"
        ></ng-select>
      </li>

      <ul class="nav ml-auto">
        <li class="nav-item vpn-status" *ngIf="userService.vpn_status">
          <a class="btn btn-xs btn-success btn-rounded text-white">
            <i class="mdi mdi-check"></i> VPN
          </a>
        </li>
        <li class="nav-item btn-group">
          <a class="nav-link" href="#" id="appsDropdown" data-toggle="dropdown" aria-expanded="false">
            <span class="avatar">{{initials | uppercase}}</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" aria-labelledby="appsDropdown">
            <a class="dropdown-item" routerLink="/user_profile">Edit Profile</a>
            <a class="dropdown-item" (click)="userService.logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav>
